import { ActionButton, Button, Chip, ChipStatusProps, Content, ContentHeader, FilterMenu, InputSearch, Menu, MenuItem, Paging, QueryState, QueryStateContent, Stack, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components'
import { XlsIcon } from 'src/app/components/Icons'
import { usePermissions } from 'src/app/hooks/permissions-hook'
import CampaignScreens from '../../../CampaignScreens'
import { Refs } from 'src/app/utils/refs-utils'
import { useSalesPromoDetailTabParticipant } from './SalesPromoDetailTabParticipant.hook'
import { FilterMenuContentParticipant } from '../LuckyDrawDetail/FilterMenuContentParticipant/FilterMenuContentParticipant'
import { useSalesPromoDetailTabDetail } from './SalesPromoDetailTabDetail.hook'
import { SalesPromoModel, SalesPromoParticipant } from '../../../models/SalesPromo.model'

export const customLDDetailParticipantStatus = (status?: string): ChipStatusProps['customOpt'] => {
  if (!status) return undefined;
  const state = status.toUpperCase();
  if (state === 'ACTIVE') {
    return {
      text: 'Active',
      variant: 'success'
    }
  }
  if (state === 'SUSPEND') {
    return {
      text: 'Suspended',
      variant: 'danger'
    }
  }
  return {
    text: 'Deleted',
    variant: 'gray'
  }
}

export default function SalesPromoDetailTabParticipant() {

  const detail = useSalesPromoDetailTabDetail();
  const generalInfo: SalesPromoModel = detail.generalInfo.data;
  const permission = usePermissions()
  const state = useSalesPromoDetailTabParticipant()

  const handleDownloadExport = async () => {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD
    const name = `campaign_listparticipants_${formattedDate}`;
    try {
      await state.exportParticipantList.download(`${name}.xlsx`, null);
      Refs.pageToast.show({
        severity: 'success',
        message: `${name} successfully exported (.xlsx).`
      });

    } catch (error) {
      console.log("🚀 ~ handleDownloadData ~ error:", error);
    }
  };

  const renderItem = (item: SalesPromoParticipant, index: number) => {
    return (
      <TableRow key={item.id}>
        <TableCell {...{ index }} />
        <TableCell value={item?.member_code} />
        <TableCell value={item?.fullname} />
        <TableCell value={item?.total_receipt} />
        <TableCell value={item?.total_point_earned} />
        {!generalInfo?.is_direct_cashback_point && <TableCell value={item?.total_prize_claimed} />}
        <TableCell action={true}>
          {permission.setVisibleByAccess(
            ['manage_campaign_sales_promo.read'],
            <ActionButton
              className="mx-auto"
              variant="detail"
              to={CampaignScreens.DETAIL_SALES_PROMO_DETAIL_PARTICIPANT.PATH.replace(':id', state.params.id!).replace(':participantId', item.id!)}
            />
          )}
        </TableCell>
      </TableRow>
    )
  }

  const renderChips = () => {
    const { data } = state.participantSummary;
    const titles = [
      {
        key: 'total_participant',
        label: 'Total Participant'
      },
      {
        key: 'total_point_earned',
        label: 'Total Point Earned'
      },
      ...(!generalInfo?.is_direct_cashback_point ? [
        {
          key: 'total_prize_claimed',
          label: 'Total Prizes Claimed'
        },
        {
          key: 'total_prize_not_claimed',
          label: 'Total Prizes Not Claimed Yet'
        },
        {
          key: 'total_prize_expired',
          label: 'Total Expired Prizes'
        },
      ] : [])
    ]
    const mappedData = titles.map((item) => {
      return {
        title: item.label,
        desc: data?.[`${item.key}`] ?? '-'
      }
    })
    return mappedData?.map(
      (chip, idx) => {
        return <Chip key={`Chip-${idx}`} variant='gray' className='bg-neutral-100 text-right rounded-md px-4 py-3'>
          <p className='text-xs text-neutral-700'>{chip.title}</p>
          <p className='text-[1rem] font-bold text-neutral-900 mt-1'>{chip.desc}</p>
        </Chip>
      }
    )
  }

  return (
    <Content>
      <ContentHeader title="Participant List"></ContentHeader>
      <Stack direction='row' className="border-b dark:border-gray-700 px-6 py-4 overflow-auto">
        {renderChips()}
        <div className='flex-1 flex justify-end align-middle'>
          <FilterMenu>
            <FilterMenuContentParticipant withTime={true} />
          </FilterMenu>
        </div>
      </Stack>

      <Stack
        direction="row"
        justify="between"
        items="center"
        className="px-6 py-4"
      >
        <Stack
          direction="row"
          justify="start"
          items="center"
        >
          <InputSearch autoFocus />
        </Stack>
        {permission.setVisibleByAccess(
          ['manage_campaign_sales_promo_export.read'],
          <Menu
            closeOnClick={true}
            className="min-w-[160px]"
            menuButton={(
              <Button loading={state.exportParticipantList.isLoading} variant="outlined">
                Export Data
              </Button>
            )}
          >
            <MenuItem startIcon={XlsIcon} onClick={handleDownloadExport}>
              Export as XLS
            </MenuItem>
          </Menu>
        )}
      </Stack>

      <QueryState query={state.participantList}>
        <div className="px-8">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell index />
                <TableCell order='member_code'>Customer ID</TableCell>
                <TableCell order='fullname'>Customer Name</TableCell>
                <TableCell order='total_receipt'>Total Receipt</TableCell>
                <TableCell order='total_point_earned'>Total Point Earned</TableCell>
                {!generalInfo?.is_direct_cashback_point && <TableCell order='total_prize_claimed'>Total Prize Claimed</TableCell>}
                <TableCell action={true} className="w-[100px]" />
              </TableRow>
            </TableHead>
            <TableBody>
              {state.participantList.data?.content?.map(renderItem)}
            </TableBody>
          </Table>
          <Paging query={state.participantList} />
        </div>
        <QueryStateContent title="List Participant is Empty" />
      </QueryState>
    </Content>
  )
}
